const COUPON_LOADING = "COUPON_LOADING";
const COUPON_ERROR = "COUPON_ERROR";
const COUPON_SUCCESS = "COUPON_SUCCESS";
export { COUPON_LOADING, COUPON_ERROR, COUPON_SUCCESS };
